import React, {FC} from 'react'
import {useEffectOnce} from 'react-use'
import {inject, observer} from 'mobx-react'
import {RouteComponentProps} from 'react-router-dom'
import {UserStoreProps} from '@/stores/user'
import classnames from 'classnames'
import Buys from '@/components/Buy'
import {Row, Col, Spin} from 'antd'
import InputNumber from '@/components/InputNumber'
import '@/styles/page/Buy.less'
import PayMethods from "@/components/service/PayMethod";
import Bottom from '@/components/service/Bottom'
import SelectForm from "@/components/Select/SelectForm";
import report from '@/utils/log'


type ButProps = RouteComponentProps & UserStoreProps

const Buy: FC<ButProps> = inject('UserStore')(observer(props => {
  const {BuyStore} = props.UserStore
  const {products, groupId, changeGroupId, togglePayType, payType, getBuyNum, prices, changePrice, totalPrice, deviceBuy, priceId, totalNum, loadding} = BuyStore
  useEffectOnce(() => {
    // 购买页面加载成功 事件上报
    report({
      eventId: 'E1400',
      pageId: 'P14',
      ext: '',
    })
    BuyStore.init()
  })
  return (
    <Spin spinning={loadding}>
      <div className='gc_buy'>
        <div className={classnames('gc_buy_product')}>
          <Row type='flex' gutter={[40, 40]}>
            {
              products.map(product => {
                return <Col key={product.productName}>
                  <Buys.Product
                    className={classnames('buys_product')}
                    changeGroupId={changeGroupId}
                    groupId={groupId}
                    product={product}></Buys.Product>
                </Col>
              })
            }
          </Row>
        </div>
        <div>
          <Row gutter={[0, 20]}>
            <Col>
              <SelectForm
                title='套餐名称'
                dataSource={prices}
                value='id'
                lable='title'
                onChange={changePrice}
                selectValue={priceId}
              ></SelectForm>
            </Col>
            <Col>
              <Row type='flex' align='middle' gutter={[12, 0]}>
                <Col>购买数量</Col>
                <Col>
                  <InputNumber min={1} className={classnames('buy_input')} onChange={getBuyNum} value={totalNum} precision={0}/>
                </Col>
              </Row>
            </Col>
            <Col>
              <Row type='flex' align='middle' gutter={[12, 0]}>
                <Col>
                  <PayMethods className={classnames('buy_methods')} payType={payType}
                              togglePayType={togglePayType}></PayMethods>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <Bottom totalPrice={totalPrice} deviceBuy={deviceBuy}></Bottom>
      </div>
    </Spin>
  )
}))

export default Buy
